export enum SaveStatuses {
    CHANGED = "changed",
    SAVING = "saving",
    SAVED = "saved",
    ERROR = "error",
    DELETED = "deleted",
    DELETING = "deleting",
    RESTORED = "restored",
    RESTORING = "restoring",
    UNCHANGED = "unchanged"
}